import { AudioDevice, AudioHost } from '@ftr/contracts/regional-api'
import { AbstractBuilder } from '@ftr/foundation'

export class AudioDeviceBuilder extends AbstractBuilder<AudioDevice> {
  constructor() {
    super({
      host: AudioHost.WindowsAsio,
      inputs: 8,
      name: 'Test Audio Device',
      outputs: 0,
    })
  }
}
